<template>
  <div class="container-index324">
    <el-row>
      <div class="index-page">
        <div class="dep-box">
          <div class="total-box">
            <el-col :span="16">
              <c-block-box
                title="总体营收"
                :tip="true"
                :data-num="numberSplitWithComma((dashboard.totalReceive.yearTotalIncome || 0))"
                class="margin-bottom-1rem zys-wrap"
              >
                <!-- <template slot="sub-title">
                  <div class="Year-To-Date">年累计 {{ numberSplitWithComma((dashboard.totalReceive.yearTotalIncome || 0)) }}</div>
                </template>
              -->
                <template slot="create-task" v-if="this.isMobile">
                  <div class="create-task" @click="turnToCreateTask(moduleResponsiblePerson.totalReceive)"><i class="el-icon-plus"></i></div>
                </template>
                <div class="revenue-total n-revenue-total">
                  <div class="the-month--revenue box">
                    <div class="re-wrap">
                      <div class="item">
                        <div class="i-title">总营收（万元）</div>
                        <div class="total-revenue">{{ numberSplitWithComma((dashboard.totalReceive.totalIncome || 0)) }}</div>
                      </div>
                      <div class="fss-total">
                        <div class="item-fss item" style="margin-bottom:10px">
                          <div class="i-title">实时（万元）:</div>
                          <div class="total-revenue">{{ numberSplitWithComma((dashboard.totalReceive.monthIncome || 0)) }}</div>
                        </div>
                        <div class="item-fss item">
                          <div class="i-title">非实时（万元）:</div>
                          <div class="total-revenue">{{ numberSplitWithComma((dashboard.totalReceive.nonRealTimeTotal || 0)) }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="revenue-statistics">
                      <div class="tendency">
                        <div class="tendency-text">
                          <span>环比</span>
                          <img :src="upsAndDowns(dashboard.totalReceive.monthRatio || 0)" />
                          <em>{{ percentage(dashboard.totalReceive.monthRatio) }}%</em>
                        </div>
                        <div class="tendency-text">
                          <span>同比</span>
                          <img :src="upsAndDowns(dashboard.totalReceive.weekRatio || 0)" />
                          <em>{{ percentage(dashboard.totalReceive.weekRatio) }}%</em>
                        </div>
                      </div>
                      <div class="revenue-target">目标 {{ numberSplitWithComma((dashboard.totalReceive.monthTarget || 0 ) * 1) + '万' }}</div>
                    </div>
                    <div class="target-rate">
                      <c-target-rate
                        label="完成率"
                        :num="percentage(dashboard.totalReceive.monthFinishRatio)"
                      >
                      </c-target-rate>
                      <c-target-rate
                        label="匹配度"
                        :num="percentage(dashboard.totalReceive.targetFinishRatio)"
                      >
                      </c-target-rate>
                    </div>
                  </div>
                  <div class="revenue-trend box">
                    <div class="title">实时营收趋势</div>
                    <ChartBarLine
                      id="revenueTrend"
                      width="100%"
                      height="9.25rem"
                      :option="revenueTrend"
                    ></ChartBarLine>
                  </div>
                  <div class="dep-revenue-trend box">
                    <div class="title">实时营收柱状图</div>
                    <ChartBarLine
                      id="dep-revenue-trend"
                      width="100%"
                      height="9.25rem"
                      :option="depRevenueTrend"
                    ></ChartBarLine>
                  </div>
                </div>
              </c-block-box>
            </el-col>
            <el-col :span="8">
              <c-block-box title="内容价值" :tip="true" class="margin-left-1rem margin-bottom-1rem padding-halfrem terimeter-lable-lists block-box-no-hidden">
                <template slot="create-task" v-if="this.isMobile">
                  <div class="create-task" @click="turnToCreateTask(moduleResponsiblePerson.terminalValue)"><i class="el-icon-plus"></i></div>
                </template>
                <el-col class="zd-price-box " :span="24">
                  <el-col class="left-info-box" :span="6">
                    <div class="item-info" v-for="item in zhongduanOptions.listsLabel" :key="item.key">
                      <span class="title">{{ item.label }}</span>
                      <p class="count">{{ item.value }}</p>
                    </div>
                  </el-col>
                  <el-col :span="18">
                    <ChartBarLine
                      id="dep-revenue-trenda"
                      width="100%"
                      height="9.25rem"
                      :option="zhongduanOptions.chart "
                    ></ChartBarLine>
                  </el-col>
                </el-col>
              </c-block-box>
            </el-col>
          </div>
          <div class="dep-box--line1">
            <el-col :span="24">
              <el-col :span="8">
                <div
                  class="coocaa_btn"
                  id="dep-1"
                  upTarget="#index"
                  depLink="/parlor"
                >
                  <c-block-box title="大内容事业部" :tip="true">
                    <template slot="create-task" v-if="this.isMobile">
                      <div class="create-task" @click="turnToCreateTask(moduleResponsiblePerson.livingRoom)"><i class="el-icon-plus"></i></div>
                    </template>
                    <div class="line-box">
                      <div class="order-complete">
                        <div class="complete-flex complete-flex0">
                          <div class="name">
                            <span class="unit-title">实时净额营收（万元）</span>
                            <template>
                              <el-popover
                                placement="top-start"
                                trigger="hover"
                                class="tipsBox"
                              >
                                <div class="tip">
                                  <div>
                                    <div class="icon_principal"></div>
                                    <span class="tips_title">负责人</span>
                                    <span class="tips_content">冯轲</span>
                                  </div>
                                  <div>
                                    <div class="icon_source"></div>
                                    <span class="tips_title">数据来源</span>
                                    <span class="tips_content">业财数据</span>
                                  </div>
                                  <div>
                                    <div class="icon_Remark"></div>
                                    <span class="tips_title">更新规则</span>
                                    <span class="tips_content">业财每天10:40更新 T-1数据</span>
                                  </div>
                                </div>
                                <i class="el-icon-info" slot="reference"></i>
                              </el-popover>
                            </template>
                          </div>
                          <div class="complete-data">
                            <div class="value">{{ numberSplitWithComma((dashboard.livingRoom.weekOpen.monthNetIncome || 0).toFixed(2)) }}</div>
                            <div class="tendency">
                              <div class="tendency-text">
                                <span>环比</span>
                                <img :src="upsAndDowns(dashboard.livingRoom.weekOpen.monthNetRatio || 0)" />
                                <em>{{ percentage(dashboard.livingRoom.weekOpen.monthNetRatio).toFixed(1) }}%</em>
                              </div>
                              <div class="tendency-text">
                                <span>同比</span>
                                <img :src="upsAndDowns(dashboard.livingRoom.weekOpen.monthYRatio || 0.01)" />
                                <em>{{ percentage(dashboard.livingRoom.weekOpen.monthYRatio).toFixed(1) }}%</em>
                              </div>
                            </div>
                          </div>
                          <div class="target">目标 {{ numberSplitWithComma((dashboard.livingRoom.weekOpen.monthTarget || 0) * 1) + '万' }}</div>
                          <div class="target-rate">
                            <c-target-rate
                              label="完成率"
                              :num="percentage(dashboard.livingRoom.weekOpen.monthFinishRatio)"
                              height="0.7rem"
                              width="6rem"
                            >
                            </c-target-rate>
                            <c-target-rate
                              label="匹配度"
                              :num="percentage(dashboard.livingRoom.weekOpen.targetFinishRatio)"
                              height="0.7rem"
                              width="6rem"
                            >
                            </c-target-rate>
                          </div>
                        </div>
                        <div class="complete-flex complete-flex1">
                          <div class="name">
                            <span class="unit-title">主页月活用户数 (万)</span>
                            <template>
                              <el-popover
                                placement="top-start"
                                trigger="hover"
                                class="tipsBox"
                              >
                                <div class="tip">
                                  <div>
                                    <div class="icon_principal"></div>
                                    <span class="tips_title">负责人</span>
                                    <span class="tips_content">王雷</span>
                                  </div>
                                  <div>
                                    <div class="icon_source"></div>
                                    <span class="tips_title">数据来源</span>
                                    <span class="tips_content">大数据平台</span>
                                  </div>
                                  <div>
                                    <div class="icon_Remark"></div>
                                    <span class="tips_title">更新规则</span>
                                    <span class="tips_content">大数据每天10点更新 T-1数据</span>
                                  </div>
                                </div>
                                <i class="el-icon-info" slot="reference"></i>
                              </el-popover>
                            </template>
                          </div>
                          <div class="complete-data">
                            <div class="value">{{ (dashboard.livingRoom.weekOpen.activeNum/10000||0.00).toFixed(1) }}</div>
                            <div class="tendency">
                              <!-- <div class="tendency-text">
                          <span>月环比</span>
                          <img :src="upsAndDowns(dashboard.livingRoom.weekOpen.activeRateCompare || 0)" />
                          <em> {{ percentage(dashboard.livingRoom.weekOpen.activeRateCompare).toFixed(2) }}%</em>
                        </div> -->
                              <div class="tendency-text">
                                <span>同比</span>
                                <img :src="upsAndDowns(dashboard.livingRoom.weekOpen.activeNumRate || 0)" />
                                <em>{{ percentage(dashboard.livingRoom.weekOpen.activeNumRate).toFixed(2) }}%</em>
                              </div>
                            </div>
                          </div>
                          <div class="target">目标 {{ (dashboard.livingRoom.weekOpen.activeNumTarget/10000).toFixed(2) }}万</div>
                          <div class="target-rate">
                            <c-target-rate
                              label="完成率"
                              :num="+percentage(dashboard.livingRoom.weekOpen.activeNumTargetRate).toFixed(2)"
                              height="0.7rem"
                              width="6rem"
                            >
                            </c-target-rate>
                          </div>
                        </div>
                        <div class="complete-flex complete-flex2">
                          <div class="name">
                            <span class="unit-title">活跃ARPU值（元）</span>
                            <template>
                              <el-popover
                                placement="top-start"
                                trigger="hover"
                                class="tipsBox"
                              >
                                <div class="tip">
                                  <div>
                                    <div class="icon_principal"></div>
                                    <span class="tips_title">负责人</span>
                                    <span class="tips_content">王雷</span>
                                  </div>
                                  <div>
                                    <div class="icon_source"></div>
                                    <span class="tips_title">数据来源</span>
                                    <span class="tips_content">大数据平台</span>
                                  </div>
                                  <div>
                                    <div class="icon_Remark"></div>
                                    <span class="tips_title">更新规则</span>
                                    <span class="tips_content">大数据每天10点更新 T-1数据</span>
                                  </div>
                                </div>
                                <i class="el-icon-info" slot="reference"></i>
                              </el-popover>
                            </template>
                          </div>
                          <!-- <div class="value">{{ ((dashboard.livingRoom.weekOpen.payConversionRate || 0) * 100).toFixed(2) }}</div> -->
                          <div class="complete-data">
                            <div class="value">{{ (dashboard.livingRoom.weekOpen.arpu||0).toFixed(2) }}</div>
                            <div class="tendency">
                              <!-- <div class="tendency-text">
                          <span>月环比</span>
                          <img :src="upsAndDowns(dashboard.livingRoom.weekOpen.weekConversionRateCompare || 0)" />
                          <em>{{ 500 }}%</em>
                        </div> -->
                              <div class="tendency-text">
                                <span>同比</span>
                                <img :src="upsAndDowns(dashboard.livingRoom.weekOpen.arpuCompare || 0)" />
                                <em>{{ (dashboard.livingRoom.weekOpen.arpuCompare||0.00).toFixed(2) }}%</em>
                              </div>
                            </div>
                          </div>
                          <div class="target">目标 {{ dashboard.livingRoom.weekOpen.arpuTarget }}元</div>
                          <div class="target-rate">
                            <c-target-rate
                              label="完成率"
                              :num="+percentage(dashboard.livingRoom.weekOpen.arpuTargetRate).toFixed(2)"
                              height="0.7rem"
                              width="6rem"
                            >
                            </c-target-rate>
                          </div>
                        </div>
                      </div>
                      <ChartBarLine
                        id="business-line"
                        width="100%"
                        height="9.75rem"
                        :option="businessLine"
                      ></ChartBarLine>
                    </div>
                  </c-block-box>
                </div>
              </el-col>
              <el-col :span="8">
                <c-block-box title="拓展终端态势" :tip="true" class="margin-left-1rem block-box-no-hidden">
                  <template slot="create-task" v-if="this.isMobile">
                    <div class="create-task" @click="turnToCreateTask(moduleResponsiblePerson.expand)"><i class="el-icon-plus"></i></div>
                  </template>
                  <el-col :span="24">
                    <el-col :span="4" class="zindex-model">
                      <div class="china-label">
                        <!-- <div class="item-info">
                          <span class="title">ARPU值(元)</span>
                          <div class="item-info-arpu">
                            <div>
                              <span class="title">直播：</span>
                              <span class="count">{{ (dashboard.media.livePayARPU||0).toFixed(2) }}</span>
                            </div>
                            &nbsp;&nbsp;&nbsp;
                            <div>
                              <span class="title">广告：</span>
                              <span class="count">{{ (dashboard.media.adDailyARPU||0).toFixed(2) }}</span>
                            </div>
                          </div>
                        </div> -->
                        <div
                          class="item-info"
                          v-for="(item,index) in chinaMapLabel"
                          :class="{
                            ac:chinaMapLabelAc === index
                          }"
                          :key="item.key"
                        >
                          <span class="title no-wrap">{{ item.label }}</span>
                          <p class="count">{{ item.value }}</p>
                        </div>
                        <!-- <div class="item-info">
                          <span class="title">直播</span>
                          <div class="item-info-arpu">
                            <div>
                              <span class="title">覆盖省份(个)：</span>
                              <span class="count">12 </span>
                            </div>
                            &nbsp;&nbsp;&nbsp;
                            <div>
                              <span class="title">用户数(万)：</span>
                              <span class="count">{{ (splitWnumber(dashboard.media.liveUserNum)|0) }}</span>
                            </div>
                          </div>
                        </div> -->
                      </div>
                    </el-col>
                    <el-col :span="20">
                      <div class="item-info-arpu-top">
                        <div class="item-info-arpu">
                          <div>
                            <span class="title">直播ARPU：</span>
                            <span class="count">{{ (dashboard.media.livePayARPU||0).toFixed(2) }}</span>
                          </div>
                            &nbsp;&nbsp;&nbsp;
                          <div>
                            <span class="title">广告ARPU：</span>
                            <span class="count">{{ (dashboard.media.adDailyARPU||0).toFixed(2) }}</span>
                          </div>
                        </div>
                      </div>
                      <echartsChina
                        ref="echartChina"
                        style="height:15.5rem"
                        :visual-map-color="['#00D8FF','#412ED0','red']"
                        :data="terimalLists"
                      ></echartsChina>
                    </el-col>
                  </el-col>
                </c-block-box>
              </el-col>
              <el-col :span="8">
                <div
                  class="line-right coocaa_btn margin-left-1rem"
                  id="dep-2"
                  upTarget="#index"
                  rightTarget="#index"
                  depLink="/digital-marketing"
                >
                  <c-block-box title="数字营销事业部" :tip="true">
                    <template slot="create-task" v-if="this.isMobile">
                      <div class="create-task" @click="turnToCreateTask(moduleResponsiblePerson.digitalMarketing)"><i class="el-icon-plus"></i></div>
                    </template>
                    <div class="line-box">
                      <div class="digital-marketing-1">
                        <div class="marketing-left">
                          <div class="title">
                            <span class="nowrap-word">实时营收（万元）</span>
                            <div class="number">{{ numberSplitWithComma((dashboard.digitalMarketing.nowIncome || 0).toFixed(2)) }}</div>
                            <!-- <div>
                              <div class="tendency-text digital-hb">
                                <span>环比</span>
                                <img :src="upsAndDowns(dashboard.digitalMarketing.monthRatio || 0)" />
                                <em>{{ percentage(dashboard.digitalMarketing.monthRatio) }}%</em>
                              </div>
                              <div class="tendency-text digital-hb">
                                <span>同比</span>
                                <img :src="upsAndDowns(dashboard.digitalMarketing.monthYRatio || 0)" />
                                <em>{{ percentage(dashboard.digitalMarketing.monthYRatio) }}%</em>
                              </div>
                            </div> -->
                          </div>
                          <div class="revenue-box">
                            <div class="reveie-floor-1">
                              <div class="revemie-row-flex">
                                <c-target-rate
                                  class="tendency-daitou"
                                  label="预计总营收"
                                  :target="numberSplitWithComma(dashboard.digitalMarketing.expectedTotalIncome)+'万'"
                                  :is-progress="false"
                                >
                                </c-target-rate>
                                <div class="tendency-text digital-hb">
                                  <span>环比</span>
                                  <img :src="upsAndDowns(dashboard.digitalMarketing.monthRatio || 0)" />
                                  <em>{{ percentage(dashboard.digitalMarketing.monthRatio) }}%</em>
                                </div>
                                <div class="tendency-text digital-hb">
                                  <span>同比</span>
                                  <img :src="upsAndDowns(dashboard.digitalMarketing.monthYRatio || 0)" />
                                  <em>{{ percentage(dashboard.digitalMarketing.monthYRatio) }}%</em>
                                </div>
                              </div>
                              <div class="revemie-row-flex">
                                <span class="revemie-end-qz">其中:</span>
                                <c-target-rate
                                  class="tendency-daitou"
                                  label="待执行"
                                  :target="numberSplitWithComma(dashboard.digitalMarketing.futureIncome)+'万'"
                                  :is-progress="false"
                                >
                                </c-target-rate>
                                <c-target-rate
                                  label="额外商机"
                                  :target="numberSplitWithComma(dashboard.digitalMarketing.proposedOrderData)+'万'"
                                  :is-progress="false"
                                >
                                </c-target-rate>
                              </div>
                            </div>
                          </div>
                          <div class="finishing-rate">
                            <c-target-rate
                              label="目标"
                              :target="(dashboard.digitalMarketing.monthTarget || 0) + '万'"
                              :is-progress="false"
                            >
                            </c-target-rate>
                            <c-target-rate
                              label="完成率"
                              :num="percentage(dashboard.digitalMarketing.monthFinishRatio) * 1"
                            >
                            </c-target-rate>
                            <!-- <c-target-rate
                              label="匹配度"
                              :num="percentage(dashboard.digitalMarketing.targetFinishRatio) * 1"
                            >
                            </c-target-rate> -->
                          </div>
                        </div>
                        <div class="marketing-right">
                          <div class="line1">
                            <span>完单率</span>
                            <em>{{ percentage(dashboard.digitalMarketing.projectRate || 0) }}%</em>
                          </div>
                          <div class="line2">
                            <div>
                              <span class="lable">执行项目数：</span>
                              <em>{{ dashboard.digitalMarketing.pfinishNum || 0 }}</em>
                            </div>
                            <div>
                              <span class="lable">缺量项目数：</span>
                              <em>{{ dashboard.digitalMarketing.pundoneNum || 0 }}</em>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="digital-marketing-2">
                        <c-block-box
                          title="开机广告城市售出率"
                          class="flex-digital-1"
                          :tip="true"
                        >
                          <div class="digital-marketing-ccProgress-wrap">
                            <div class="item" v-for="(item,index) in dashboard.digitalMarketing.deliveryChannel" :key="index">
                              <div class="label-wrap">
                                <span class="name">{{ item.cityName }}</span>
                                <span class="kc">库存：{{ numberSplitWithComma(item.stock) }}cpm</span>
                                <span class="percent">{{ percentage(item.sellRate) }}%</span>
                              </div>
                              <CcProgress
                                :style-wrap="{
                                  height: '5px',
                                  width: '100%',
                                  'background-color': '#383451'
                                }"
                                :color="CcProgressColor[index]"
                                :num="+percentage(item.sellRate)"
                              ></CcProgress>
                            </div>
                          </div>
                        </c-block-box>
                        <c-block-box
                          title="代理商贡献占比"
                          class="flex-digital-2"
                          :tip="true"
                        >
                          <div class="pro-contri-wrap">
                            <ProportionAgentContribution :series-type="seriesType" :data="dashboard.digitalMarketing.contributionProportion"></ProportionAgentContribution>
                          </div>
                        </c-block-box>
                      </div>
                    </div>
                  </c-block-box>
                </div>
              </el-col>
            </el-col>
          </div>
          <div class="dep-box--line2">
            <el-col :span="8">
              <c-block-box title="语音业务" :tip="true" class="voice-box block-box-no-hidden">
                <template slot="create-task" v-if="this.isMobile">
                  <div class="create-task" @click="turnToCreateTask(moduleResponsiblePerson.voiceOptions)"><i class="el-icon-plus"></i></div>
                </template>
                <el-col class="zd-price-box" :span="24">
                  <el-col class="left-info-box voice-label-lists" :span="6">
                    <div class="item-info" v-for="item in voiceOptions.listsLabel" :key="item.key">
                      <span class="title">{{ item.label }}</span>
                      <p class="count">{{ item.value }}</p>
                    </div>
                  </el-col>
                  <el-col :span="18">
                    <ChartBarLine
                      id="dep-revenue-trendc"
                      width="100%"
                      height="12rem"
                      :option="voiceOptions.chart"
                    ></ChartBarLine>
                  </el-col>
                </el-col>
              </c-block-box>
            </el-col>
            <div
              class="coocaa_btn line-left margin-leftright margin-left-1rem"
              id="dep-3"
              depLink="/media-financial"
            >
              <c-block-box title="系统拓展事业部" :tip="true">
                <template slot="create-task" v-if="this.isMobile">
                  <div class="create-task" @click="turnToCreateTask(moduleResponsiblePerson.media)"><i class="el-icon-plus"></i></div>
                </template>
                <div class="line-box">
                  <div class="media-financial--left">
                    <div class="title">
                      <span class="unit-title">营收（万元）</span>
                      <template>
                        <el-popover
                          placement="top-start"
                          trigger="hover"
                          class="tipsBox"
                        >
                          <div class="tip">
                            <div>
                              <div class="icon_principal"></div>
                              <span class="tips_title">负责人</span>
                              <span class="tips_content">冯轲</span>
                            </div>
                            <div>
                              <div class="icon_source"></div>
                              <span class="tips_title">数据来源</span>
                              <span class="tips_content">业财数据</span>
                            </div>
                            <div>
                              <div class="icon_Remark"></div>
                              <span class="tips_title">更新规则</span>
                              <span class="tips_content">业财每天10:40更新 T-1数据</span>
                            </div>
                          </div>
                          <i class="el-icon-info" slot="reference"></i>
                        </el-popover>
                      </template>
                    </div>
                    <div class="value">{{ (dashboard.media.monthIncome || 0).toFixed(2) }}</div>
                    <div class="tendency">
                      <div class="tendency-text">
                        <span>环比</span>
                        <img :src="upsAndDowns(dashboard.media.monthRatio)" />
                        <em>{{ percentage(dashboard.media.monthRatio) }}%</em>
                      </div>
                      <div class="tendency-text">
                        <span>同比</span>
                        <img :src="upsAndDowns(dashboard.media.monthYRatio)" />
                        <em>{{ percentage(dashboard.media.monthYRatio) }}%</em>
                      </div>
                    </div>
                    <div class="target">目标 {{ dashboard.media.monthTarget * 1 + '万' }}</div>
                    <div class="target-rate">
                      <c-target-rate
                        label="完成率"
                        :num="percentage(dashboard.media.monthFinishRatio)"
                      >
                      </c-target-rate>
                      <c-target-rate
                        label="匹配度"
                        :num="percentage(dashboard.media.targetFinishRatio)"
                      >
                      </c-target-rate>
                    </div>
                  <!-- <div class="Year-To-Date">年累计 {{ (dashboard.media.yearTotalIncome || 0).toFixed(2) }}</div> -->
                  </div>
                  <div class="media-financial--right">
                    <div class="title">
                      <span class="unit-title">累计终端数及占比  </span>
                      <template>
                        <el-popover
                          placement="top-start"
                          trigger="hover"
                          class="tipsBox"
                        >
                          <div class="tip">
                            <div>
                              <div class="icon_principal"></div>
                              <span class="tips_title">负责人</span>
                              <span class="tips_content">王雷</span>
                            </div>
                            <div>
                              <div class="icon_source"></div>
                              <span class="tips_title">数据来源</span>
                              <span class="tips_content">大数据平台</span>
                            </div>
                            <div>
                              <div class="icon_Remark"></div>
                              <span class="tips_title">更新规则</span>
                              <span class="tips_content">大数据每天10点更新 T-1数据</span>
                            </div>
                          </div>
                          <i class="el-icon-info" slot="reference"></i>
                        </el-popover>
                      </template>
                    </div>
                    <ChartPie
                      id="media-financial-pie"
                      height="6rem"
                      width="6rem"
                      style="margin-top: 1rem"
                      :option="mediaFinancialPie"
                    ></ChartPie>
                    <div class="media-financial-legend">
                      <div class="line" v-for="(item, index) in mediaFinancialPie.data" :key="index">
                        <span>{{ item.name }}</span>
                        <em>{{ item.num }}万台</em>
                        <em>{{ item.value }}%</em>
                      </div>
                    </div>
                  </div>
                </div>
              </c-block-box>
            </div>
            <div
              class="line-right coocaa_btn margin-left-1rem"
              id="dep-4"
              rightTarget="#index"
              depLink="/share-screen"
            >
              <TyyDetailTable :tyy-detail-table-visiable="tyyDetailTableVisiable" @closeDialogEvent="closeDialogEvent"></TyyDetailTable>
              <c-block-box
                v-if="targetYear() >= 2023"
                title="投影仪"
                :tip="true"
                class="block-box-no-hidden"
              >
                <template slot="create-task" v-if="this.isMobile">
                  <div class="create-task" @click="turnToCreateTask(moduleResponsiblePerson.rongmeiaOptions)"><i class="el-icon-plus"></i></div>
                </template>
                <span class="qeys-title-slot" @click="tyyDetailTableVisiable = true">详情</span>
                <el-col class="zd-price-box" :span="24">
                  <el-col class="left-info-box rong-label-lists" :span="6">
                    <div
                      style="margin-bottom: 0.2rem;"
                      class="item-info"
                      v-for="item in touyingyiOptions.listsLabel"
                      :key="item.label"
                    >
                      <span class="title">{{ item.label }}</span>
                      <p class="count" style="margin-bottom: 0.2rem;font-size: 0.8rem;">{{ item.value }}</p>
                    </div>
                  </el-col>
                  <el-col :span="18">
                    <ChartBarLineTwo
                      id="dep-revenue-trend1"
                      width="100%"
                      height="12rem"
                      :option="touyingyiOptions.chart"
                    ></ChartBarLineTwo>
                  </el-col>
                </el-col>
              </c-block-box>
              <c-block-box
                v-else
                title="融媒体"
                :tip="true"
                class="block-box-no-hidden"
              >
                <el-col class="zd-price-box" :span="24">
                  <el-col class="left-info-box rong-label-lists" :span="6">
                    <div class="item-info" v-for="item in rongmeiaOptions.listsLabel" :key="item.label">
                      <span class="title">{{ item.label }}</span>
                      <p class="count">{{ item.value }}</p>
                    </div>
                  </el-col>
                  <el-col :span="18">
                    <ChartBarLine
                      id="dep-revenue-trend1"
                      width="100%"
                      height="12rem"
                      :option="rongmeiaOptions.chart"
                    ></ChartBarLine>
                  </el-col>
                </el-col>
              </c-block-box>
            </div>
          </div>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
import CcProgress from '@/components/DigitalMarketing/CcProgress'
import ProportionAgentContribution from '@/components/DigitalMarketing/ProportionAgentContribution'

import ChartPie from '@/components/echarts/pie'
import ChartBarLine from '@/components/echarts/line1'
import ChartBarLineTwo from '@/components/echarts/lineColumnChart'
import * as echarts from 'echarts'
import echartsChina from '@/components/echarts/echartsChina'
import TyyDetailTable from '../../../components/echarts/TyyDetailTable.vue'
import { Message } from 'element-ui'

import common from '@/mixins/common.js'
import scalseNum from '@/mixins/scalseNum.js'
import { zd, zhongduanfenbuChartOptions, voice, rongmeiti, touyingyi, setChinaLabel } from './js/Index-3.2.4.js'
import store from '@/store'
export default {
  mixins: [common, scalseNum],
  components: {
    ChartPie,
    ChartBarLine,
    ChartBarLineTwo,
    CcProgress,
    ProportionAgentContribution,
    echartsChina,
    TyyDetailTable
  },
  props: {},
  data () {
    return {
      zhongduanOptions: {
        chart: {},
        listsLabel: []
      },
      voiceOptions: {// 语音
        chart: {},
        listsLabel: []
      },
      rongmeiaOptions: {// 融媒体
        chart: {},
        listsLabel: []
      },
      // 投影仪
      touyingyiOptions: {
        chart: {},
        listsLabel: []
      },
      tyyDetailTableVisiable: false,
      terimalLists: {}, // 终端
      chinaMapLabel: [], // 地图旁边的label
      CcProgressColor: ['#017cfb', '#1ee4dc', '#ffd71c'],
      seriesType: { radius: ['45%', '85%'],
        center: ['35%', '55%'] },
      revenueTrend: {
        grid: {
          left: 10,
          right: 20,
          bottom: 10,
          containLabel: true
        },
        legend: {},
        xData: [],
        series: [],
        boundaryGap: false,
        color: ['#1895FF', '#1EE4DC', '#FFA800']
      },
      depRevenueTrend: {
        grid: {
          left: 10,
          right: 20,
          bottom: 10,
          containLabel: true
        },
        legend: {},
        boundaryGap: true,
        alignWithLabel: true,
        color: ['#1895FF', '#1EE4DC', '#FFD71A'],
        xData: [],
        series: []
      },
      businessLine: {
        title: {
          text: '各业务营收曲线',
          x: 'left',
          left: 20,
          top: 15,
          textStyle: {
            fontSize: 14,
            color: 'rgba(255,255,255,.6)',
            lineHeight: 30
          }
        },
        legend: {
          top: 20
        },
        grid: {
          left: 10,
          right: 20,
          bottom: 10,
          top: 60,
          containLabel: true
        },
        boundaryGap: false,
        color: ['#FF5A18', '#FFD71A', '#1895FF', '#1EE4DC'],
        xData: [],
        series: []
      },
      shareLine: {
        config: {
          legend: {
            orient: 'vertical',
            right: this.$isAndroid ? 0 : 10,
            top: this.$isAndroid ? 10 : 20
          },
          grid: {
            left: this.$isAndroid ? 0 : 10,
            right: 20,
            bottom: this.$isAndroid ? 10 : 0,
            top: this.$isAndroid ? 85 : 80,
            containLabel: true
          },
          boundaryGap: false,
          splitNumber: 2,
          yAxis: [
            {
              name: '人',
              type: 'value',
              splitLine: {
                lineStyle: {
                  color: 'rgba(255,255,255,0.1)'
                }
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: 'rgba(255,255,255,0.1)'
                }
              },
              axisLabel: {
                textStyle: {
                  color: 'rgba(255,255,255,.6)',
                  fontSize: !this.$isAndroid ? 12 : 10
                }
              },
              nameTextStyle: {
                color: '#999',
                fontSize: !this.$isAndroid ? 12 : 10
              },
              splitArea: {
                show: false
              },
              splitNumber: 2
            }
          ]
        },
        series: []
      },

      mediaFinancialPie: {
        config: {
          type: 2,
          picRadius: ['100%', '70%'],
          tooltip: {
            show: false
          },
          seriesLabel: {
            show: false
          },
          legend: {
            show: false,
            right: 30,
            bottom: 30
          }
        },
        data: []
      },
      businessRatio: {
        config: {
          type: 2,
          picRadius: '65%',
          picCenter: ['50%', '35%'],
          tooltip: {
            show: true
          },
          legend: {
            bottom: 0,
            height: this.$isAndroid ? 30 : 40,
            textStyle: {
              fontSize: this.$isAndroid ? 10 : 12,
              color: 'rgba(255, 255, 255, 0.8)'
            }
          }
        },
        data: []
      },
      accountReceivableRatio: {
        config: {
          type: 2,
          picRadius: '80%',
          picCenter: ['30%', '50%'],
          tooltip: {
            show: true
          },
          legend: {
            right: 20,
            y: 'center'
          }
        },
        data: [
          { name: '创维终端', value: '78' },
          { name: '外部终端', value: '22' }
        ]
      },
      dashboard: {
        totalReceive: {},
        livingRoom: {
          weekOpen: {}
        },
        digitalMarketing: {
          monthRecord: {}
        },
        share: {},
        media: {},
        monthIncome: {
          monthIncome: {}
        }
      },
      chinaMapLabelAc: 3,
      chinaMapLabelAcInter: null,
      moduleResponsiblePerson: { // 各模块负责人
        totalReceive: 'CC0735', // 总营收
        terminalValue: 'CC1867', // 内容价值
        livingRoom: 'CC0735,CC1867', // 大内容事业部
        expand: 'CC1867', // 拓展终端态势
        digitalMarketing: 'CC0735,CC1492', // 数字营销事业部
        voiceOptions: 'CC0756', // 语音业务
        media: 'CC0735,CC1867', // 系统拓展事业部
        rongmeiaOptions: 'CC0735' // 融媒体
      },
      ttcToken: '' // ttc系统的token
    }
  },
  computed: {
    isAndroid () {
      return this.$store.state.app.isAndroid
    }
  },
  methods: {
    percentage (num) {
      if (isNaN(num)) { return 0 }
      return parseFloat((num * 100).toFixed(2))
    },
    turnToCreateTask (empId) {
      let url = process.env.NODE_ENV !== 'production' ? 'https://dev-mobile-ttc.coocaa.com/createTaskPages' : 'https://mobile-ttc.coocaa.com/createTaskPages'
      let origin = window.location.origin
      let path = `${url}?source=kanban&url=${origin}&empId=${empId}&token=${this.ttcToken}&lk_meta=%7B%22page-meta%22%3A%7B%22orientation%22%3A%22portrait%22%7D%7D`
      if (this.ttcToken) {
        if (this.IsAndroid) {
          window.location.href = path
        } else {
          window.open(path)
        }
      } else {
        Message({
          showClose: true,
          message: '异常提示：获取授权失败，请联系看板管理员！',
          type: 'error'
        })
      }
    },
    lineFormatData (data, series, dashedType, type) {
      const keys = Object.keys(data)
      return {
        xData: data[keys[0]].date.map(item => {
          return this.$cUtils.format.formatDate(item, 'MM-dd')
        }),
        series: keys.map(item => {
          let areaStyle = {}
          if (type && item !== dashedType) {
            areaStyle = {}
            this.$set(areaStyle, 'areaStyle', {})
          }
          let barWidth = 5
          if (series.type === 'bar') {
            if (data[item].data.length > 0 && data[item].data.length <= 10) {
              barWidth = 20
            } else if (data[item].data.length > 10 && data[item].data.length <= 20) {
              barWidth = 15
            }
          }
          return {
            name: item,
            data: data[item].data,
            stack: item === dashedType ? '' : '总量',
            lineStyle: {
              width: this.isAndroid ? 0.5 : 2,
              type: item === dashedType ? 'dashed' : 'solid'
            },
            barWidth,
            ...series,
            ...areaStyle
          }
        })
      }
    },
    lineFormatDataTwo (data, series) {
      const keys = Object.keys(data)
      return {
        config: {
          ...this.shareLine.config,
          xData: data[keys[0]].date.map(item => {
            return this.$cUtils.format.formatDate(item, 'MM-dd')
          })
        },
        data: keys.map((item, index) => {
          return {
            name: item,
            data: data[item].data,
            lineStyle: {
              type: item === '目标' ? 'dashed' : 'solid',
              width: this.isAndroid ? 0.5 : 2
            },
            // yAxisIndex: index,
            ...series
          }
        })
      }
    },
    targetYear () {
      return Number(JSON.parse(sessionStorage.getItem('toggleDate')).time.split('-')[0])
    },
    closeDialogEvent (val) {
      this.tyyDetailTableVisiable = val
    },
    getTTCToekn (email) {
      this.$service.fetch({
        method: 'POST',
        url: '/api/open-api/authorization/email',
        params: {
          code: email
        }
      }).then(res => {
        this.ttcToken = res.token
        sessionStorage.setItem('ttcToken', this.ttcToken)
      })
    }
  },
  activated () {
    const choiceDate = JSON.parse(sessionStorage.getItem('toggleDate'))
    this.$service.fetch({
      url: 'api/global/dashboard_v2',
      params: {
        month: choiceDate.time // '2021-01'
      }
    }).then(res => {
      this.$set(this, 'dashboard', res)
      const lineConfig = {
        symbol: 'none',
        type: 'line',
        stack: '',
        lineStyle: {
          width: this.isAndroid ? 0.5 : 2
        }
        // smooth: true
      }
      const totalReceive = res.totalReceive
      const livingRoom = res.livingRoom
      const share = res.share
      const skyWorthIncomeDetail = totalReceive.skyWorthIncomeDetail
      const businessIncomeDetail = totalReceive.businessIncomeDetail
      this.revenueTrend = Object.assign(this.revenueTrend, this.lineFormatData(skyWorthIncomeDetail, {
        symbol: 'none',
        type: 'line'
        // smooth: true
      }, '目标', 1), {})
      this.depRevenueTrend = Object.assign(this.depRevenueTrend, this.lineFormatData(businessIncomeDetail, {
        symbol: 'none',
        type: 'bar',
        barCateGoryGap: 1,
        // smooth: true,
        stack: '总量'
      }))
      this.$set(this.revenueTrend.grid, 'top', !this.isAndroid ? 60 : 40)
      this.$set(this.revenueTrend.legend, 'top', !this.isAndroid ? 20 : 10)
      this.$set(this.depRevenueTrend.grid, 'top', !this.isAndroid ? 60 : 40)
      this.$set(this.depRevenueTrend.legend, 'top', !this.isAndroid ? 20 : 10)
      // this.depRevenueTrend = Object.assign(this.depRevenueTrend, this.lineFormatData(businessIncomeDetail, lineConfig))
      this.businessLine = Object.assign(this.businessLine, this.lineFormatData(livingRoom.monthDetail, lineConfig))
      this.shareLine = Object.assign(this.shareLine, this.lineFormatDataTwo(share.user, {
        symbol: 'none',
        type: 'line'
      }))

      this.mediaFinancialPie.data = res.media.pieChart.map(item => {
        return {
          name: item.name,
          value: parseFloat((item.value * 100).toFixed(2)),
          num: parseFloat(((item.name.indexOf('创维') >= 0 ? res.media.skyWorth : res.media.other) / 10000).toFixed(2))
        }
      })

      const pieDigital = res.digitalMarketing.day || {}
      if (Object.keys(pieDigital).length > 0) {
        this.businessRatio.data = [{
          name: '创意流量',
          value: (pieDigital.creativeFlowRatio * 100).toFixed(2)
        }, {
          name: '常规流量',
          value: (pieDigital.regularFlowRatio * 100).toFixed(2)
        }, {
          name: '数据精准',
          value: (pieDigital.accurateFlowRatio * 100).toFixed(2)
        }, {
          name: '常规精准',
          value: (pieDigital.ordinaryAccurateFlowRatio * 100).toFixed(2)
        }]
      } else {
        this.businessRatio.data = []
      }

      this.accountReceivableRatio.data[0].value = (res.monthIncome.skyWorthRatio * 100).toFixed(2)
      this.accountReceivableRatio.data[1].value = (res.monthIncome.otherRatio * 100).toFixed(2)
      this.$nextTick(() => {
        this.$parent.bindKey()
      })

      // 终端价值
      this.zhongduanOptions = zd(res.terminalValue)
      this.zhongduanOptions.chart = Object.assign(this.zhongduanOptions.chart, this.lineFormatData(res.terminalValue.monthDetail, {
        symbol: 'none',
        type: 'bar',
        barCateGoryGap: 1,
        // smooth: true,
        stack: '总量'
      }))
      this.zhongduanOptions.chart.series[0].type = 'line'
      this.zhongduanOptions.chart.series[0].yAxisIndex = 1
      // 终端分布
      this.terimalLists = res.media
      this.$nextTick(() => {
        zhongduanfenbuChartOptions(this)
      })
      // 语音业务
      this.voiceOptions = voice({ res: res.voice, vue: this })
      // 投影仪 原融媒体
      this.rongmeiaOptions = rongmeiti({ res: res.mediaNewVo, vue: this })
      // 投影仪
      this.touyingyiOptions = touyingyi({ res: res.procectorVo, vue: this })
      // 中国地图旁边的label
      this.chinaMapLabel = setChinaLabel({ res })
    }).finally(() => {
      const date = new Date()
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const fullMonth = month < 10 ? '0' + month : month
      this.$service.fetch({
        url: 'api/global/abnormal',
        params: {
          month: `${year}-${fullMonth}`
        }
      }).then(res => {
        if (res) {
          // sessionStorage.setItem('abnormal', true)
          // store.commit('setAbnormal', true)
          store.commit('setAbnormal', true)
          if (sessionStorage.getItem('abnormal')) return
          sessionStorage.setItem('abnormal', true)
          this.$confirm('总体营收数据异常，请点击顶部【异常分析查看】', '数据异常提醒', {
            confirmButtonText: '立即查看',
            cancelButtonText: '取消',
            customClass: 'confirm-custion-class'
          }).then(() => {
            window.open('https://coocaa.feishu.cn/docx/TnladWViBoQTp0xpacac38lonjb')
          }).catch(() => {})
        } else {
          store.commit('setAbnormal', false)
          sessionStorage.setItem('abnormal', '')
        }
      })
    })
    if (sessionStorage.getItem('ttcToken')) {
      this.ttcToken = sessionStorage.getItem('ttcToken')
    } else {
      this.$service.fetch({
        url: '/api/global/user/info'
      }).then(res => {
        this.getTTCToekn(res.email)
      })
    }
    // if (this.chinaMapLabelAcInter) {
    //   clearInterval(this.chinaMapLabelAcInter)
    // } else {
    //   this.chinaMapLabelAcInter = setInterval(() => {
    //     this.chinaMapLabelAc++
    //     this.chinaMapLabelAc = this.chinaMapLabelAc > 2 ? 0 : this.chinaMapLabelAc
    //   }, 5000)
    // }
  }
}
</script>

<style lang="stylus" scoped>
  @import '../stylus/Index.styl'
  .container-index324
    flex 1 1
  .flex-gx
    display flex
  #no-flex
    display initial
    .revenue-box-right
      padding-left 0
  .digital-marketing-ccProgress-wrap
    padding .9rem 1rem 0rem 1rem
    display flex
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    color #fff
    .label-wrap
      display flex
      justify-content space-between
      margin-bottom .5rem
  .flex-digital-1
    flex-basis 53%
    .pro-contri-wrap
      height 7.5rem
    >>> .unit-header
          line-height: 2rem;
          height: 2rem;
          font-size: .8rem;

  .flex-digital-2
    flex-basis 46%
    .pro-contri-wrap
      height 7.5rem
    >>> .unit-header
          line-height: 2rem;
          height: 2rem;
          font-size: .8rem;
  .digital-marketing-2
    justify-content: space-between;
    .item
      margin-bottom: .5rem
    .label-wrap
      font-size .7rem
      margin-bottom: .8rem
.total-box
  overflow:hidden
.block-box-no-hidden
  position: relative
  >>>
    .unit-body
      overflow:hidden

.left-info-box
  display flex
  flex-direction column

.item-info
  color #fff
  .title
    font-size .8rem
    margin-bottom .3rem
    display inline-block
    color rgba(255,255,255,0.8)
  .count
    font-size 1.5rem

.margin-left-1rem
  margin-left 1rem
.zd-price-box
  padding-left 1rem

.voice-label-lists,.rong-label-lists,.china-label
  padding-top 1rem
  .item-info
    margin-bottom 1rem
    .count
      font-size 1.2rem
.terimeter-lable-lists
  .item-info
      margin-bottom .6rem
    .count
        font-size 1.2rem
.china-label
  margin-left .5rem
  .item-info
    padding: .3rem 0;
    overflow: hidden;
    width: 6rem;
    text-align center
    background-color #272343
    border-radius: 0.4rem
  .item-info.ac
    background-color: #0072ff;

.zindex-model
  position relative
  z-index 10

.item-info-arpu
  display flex
  white-space nowrap
  padding-right 1rem
.no-wrap
  white-space nowrap

.dep-box
  margin-right 0

.item-info-arpu
  height 2rem
  line-height 2rem
  justify-content: flex-end
  .title
    font-size .8rem
    color rgba(255,255,255,0.8)
  .count
    color #fff
    font-size 1.3rem
.index-page
 .dep-box
  margin-right 0rem

.marketing-right
  margin-left auto

.index-page .line-right .marketing-left .revenue-box .digital-hb
  padding: 0rem;
.digital-hb
  margin-left 1rem
  line-height: 1.1rem;
  height: 1.1rem;
  font-size: 0.7rem;
  color: rgba(255,255,255,0.8);
  white-space: nowrap;
  padding: 0rem;
  margin-top: -0.08rem;
  img
    width: 0.6rem;
    vertical-align: middle;
    margin: 0 0.2rem;
.index-page .line-right .marketing-left .revenue-box .tendency-daitou
  margin-left 0

.nowrap-word
  white-space nowrap

.index-page .line-right .marketing-left .revemie-row-flex
  display flex
  line-height: 1rem
  .revemie-end-qz
    color rgba(255,255,255,0.8)
    font-size 0.7rem
    margin-right .5rem
  .c-target-rate
    line-height: 1.1rem

.finishing-rate
  margin-top .3rem
.qeys-title-slot
  background rgba(24,150,255, .4)
  color rgba(255,255,255,.8)
  border 1px solid rgba(24,150,255, .6)
  font-size .7rem
  line-height 1.2rem
  padding 0 .5rem
  border-radius .3rem
  margin-left: .3rem
  display inline-block
  position:absolute
  right: 60px
  top: 10px
  cursor pointer

.icon_principal,.icon_source,.icon_Remark
  display: inline-block
  width .4rem
  height .4rem
  border-radius 50%
  margin-right .2rem

.icon_principal
  background #EA4AD3
.icon_source
  background #0080FF
.icon_Remark
  background #7D4AEA
.tipsBox
  margin-right auto
.tips_title
  font-size 0.6rem
  display inline-block
  width 2.4rem
  margin-right 1rem
.tips_content
  font-size 0.7rem
  font-weight 500

.create-task
  width:1.35rem
  height:1.35rem
  border-radius: 50%
  background: rgba(0,128,255,0.21);
  border: 0.05rem solid rgba(56,214,255,0.28);
  position: absolute;
  right: 1rem;
  top: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.5rem;
  color: #fff;
</style>

<style lang="stylus">
.confirm-custion-class
  .el-message-box__title
    font-size .8rem
  .el-message-box__container
    padding 1rem 0
</style>
